import React, { useState } from "react";
import "./ContactForm.css";
function ContactForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    query: "",
  });

  const handleChange = (e) => {
    setFormData({ [e.target.name]: e.target.value });
  };

  function handleClear() {
    setFormData({ fullName: "", email: "", query: "" });
  }
  return (
    <div className="contactForm-wrapper">
      <h2>Request a Quote</h2>
      <p>
        If you have any question just fill up the form & I will get back to you
        soon.
      </p>

      <form method="post" netlify>
        <div className="contactInput">
          <label htmlFor="fullName">
            Full Name: <span>*</span>
          </label>{" "}
          <br />
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            placeholder="Enter you Name..."
            onChange={handleChange}
            required
          />
        </div>
        <div className="contactInput">
          <label htmlFor="email">
            Email: <span>*</span>
          </label>{" "}
          <br />
          <input
            type="email"
            name="email"
            placeholder="Enter you Email..."
            onChange={handleChange}
            value={formData.email}
            required
          />
        </div>
        <div className="contactInput">
          <label htmlFor="query">
            Query: <span>*</span>
          </label>{" "}
          <br />
          <textarea
            name="query"
            id="query"
            cols="30"
            value={formData.query}
            rows="5"
            placeholder="Mention your concern here..."
            required
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="cont-buttons">
          <button onClick={handleClear}>Reset</button>
          <button type="submit">Send!</button>
        </div>
      </form>
    </div>
  );
}

export default ContactForm;
